import { loginByTokenComponent } from './loginByToken.component';

export const loginByTokenStateName = 'app.loginByToken';

export const loginByTokenState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: loginByTokenStateName,
    url: '/loginByToken?token?ticketId',
    params: {
      token: null,
      ticketId: null,
    },
    component: loginByTokenComponent.name,
  });
};
